module.exports = __webpack_public_path__ + "img/rabbit.7581cec.png";